<template>
    <img src="/webroot/images/spinner.gif" class="center-block" style="display: inline-block" height="30" width="30">
</template>

<script>
    export default {
        name: "small-spinner"
    }
</script>

<style>

</style>
